module.exports = require("./qu.d.ts");